import { render } from "./ApplyTargetCard.vue?vue&type=template&id=d6b70fd8&scoped=true&ts=true"
import script from "./ApplyTargetCard.vue?vue&type=script&lang=ts"
export * from "./ApplyTargetCard.vue?vue&type=script&lang=ts"

import "./ApplyTargetCard.vue?vue&type=style&index=0&id=d6b70fd8&scoped=true&lang=css"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b70fd8"]])

export default __exports__